module.exports = __webpack_public_path__ + "media/images/filter-2-720dcded60f107a43fcef22e7f9dd74b.svg";